import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare } from '@fortawesome/pro-solid-svg-icons';

// Styles
import styles from './ListItem.module.css';

// Utils
import cn from '../../../utils/cn';

// Components
import Picto from '../../atoms/Picto/Picto';

/**
 *
 * @param {object} props
 * @param {number | string} props.id
 * @param {string} props.label
 * @param {boolean} [props.isDisabled = false] - When true, disables drag-and-drop for this row
 * @param {React.ReactNode | null} [props.children = null]
 * @param {string} [props.color = '']
 * @param {(event: React.MouseEvent<HTMLButtonElement>) => void} [props.onClick]
 * @returns {JSX.Element} The ListItem component
 */
function ListItem({
  id, label, isDisabled = false, children = null, color = '', onClick,
}) {
  const hasColor = color && color !== 'transparent';
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
    disabled: isDisabled,
  });

  return (
    <button
      type="button"
      key={id}
      className={cn([
        styles.item,
        isDisabled && styles['item-disabled'],
      ])}
      ref={setNodeRef}
      style={{
        transform: CSS.Translate.toString(transform),
        transition,
        zIndex: isDragging ? 2 : 'auto',
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...attributes}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...listeners}
      onClick={onClick}
    >
      <div className={styles['item-info']}>
        <div className={styles['item-info-left']}>
          {!isDisabled ? (
            <Picto
              icon="drag-horizontal"
              className={styles['dnd-icon']}
            />
          ) : null}
          <div className={styles['item-name']} title={label}>
            {hasColor ? (
              <FontAwesomeIcon
                icon={faSquare}
                className={styles['item-color-icon']}
                style={{ color }}
                aria-label={`Couleur: ${color}`}
              />
            ) : null}
            <span className={styles['item-name-text']}>{label}</span>
          </div>
        </div>
        <div className={styles['item-info-right']}>
          {children || null}
        </div>
      </div>
    </button>
  );
}

export default ListItem;
